export default __webpack_public_path__ + "static/media/Avatar.4b4028ba.jpeg";